import { ConditionDescription } from './ConditionDescription';
import { ValidateDescription } from './ValidateDescription';

export interface PropertyDescription {
    label: string;
    name: string;
    type: PropertyTypeDescription;
    componentType: ComponentTypeDescription;
    required: boolean;
    condition: ConditionDescription | null;
    properties: Record<string, PropertyDescriptionTypes> | null;
    validate: ValidateDescription[] | null;
    description: string | null;
    readonly: boolean;
    defaultValueForFailedCondition: null | number | string;
}

export interface SelectPropertyDescription extends PropertyDescription {
    options: OptionDescription[];
}

export interface OptionDescription {
    value: string | number;
    label: string;
}

export interface NumberPropertyDescription extends PropertyDescription {
    min: number;
    max: number;
}

export interface StringPropertyDescription extends PropertyDescription {
    minLength: number;
    maxLength: number;
    pattern: string;
    forbiddenCharsPattern: string;
}

export enum PropertyTypeDescription {
    String = 'string',
    Number = 'number',
    Boolean = 'boolean'
}

export enum ComponentTypeDescription {
    Fieldset = 'fieldset',
    Select = 'select',
    Text = 'text',
    Date = 'date',
    Address = 'address',
    YearsMonths = 'yearsMonths',
    Number = 'number',
    RadioGroup = 'radioGroup',
    SortCode = 'sortCode',
    CheckBox = 'checkBox'
}

export type PropertyDescriptionTypes = PropertyDescription | SelectPropertyDescription | NumberPropertyDescription | StringPropertyDescription;
